import type { Maybe } from '../../../types'
import { RequestStateStatus } from './types'

export type RequestState = {
  status: RequestStateStatus
  error: Maybe<string>
}

export const requestInitialState: RequestState = {
  status: 'initial',
  error: null,
}
